module.exports = __webpack_public_path__ + "static/media/t2.f5b339d5.png";